/*
 * Reducer actions related with create case
 */
import * as types from './types';

export function clearCase() {
  return {
    type: types.CLEAR_CASE
  };
}

export function clearCaseThenNavigate(toScreen) {
  return {
    type: types.CLEAR_CASE_THEN_NAVIGATE_REQUEST,
    toScreen: toScreen
  };
}

export function getAllMyCases() {
  return {
    type: types.GET_ALL_MY_CASES
  };
}

export function getAllMyCasesResponse(cases, contacts) {
  return {
    type: types.GET_ALL_MY_CASES_RESPONSE,
    cases,
    contacts
  };
}

export function getAllMyCasesFailed(error) {
  return {
    type: types.GET_ALL_MY_CASES_FAIL,
    error
  };
}

export function requestCreateCase(createCaseRequest) {
  return {
    type: types.CREATE_CASE_REQUEST,
    newCaseRequest: createCaseRequest
  };
}

export function createCaseFailed(error) {
  return {
    type: types.CREATE_CASE_FAILED,
    error
  };
}

export function onCreateCaseResponse(response) {
  return {
    type: types.CREATE_CASE_RESPONSE,
    response
  };
}
export function requestUpdateCaseBasicInfo(editCaseBasicInfoRequest) {
  return {
    type: types.UPDATE_CASE_BASICINFO_REQUEST,
    updateCaseBasicInfoRequest: editCaseBasicInfoRequest
  };
}

export function updateCaseBasicInfoFailed(error) {
  return {
    type: types.UPDATE_CASE_BASICINFO_FAILED,
    error
  };
}

export function onUpdateCaseBasicInfoResponse(response) {
  return {
    type: types.UPDATE_CASE_BASICINFO_RESPONSE,
    response
  };
}

export function requestUpdateCaseContactInfo(editCaseContactInfoRequest) {
  return {
    type: types.UPDATE_CASE_CONTACTINFO_REQUEST,
    updateCaseContactInfoRequest: editCaseContactInfoRequest
  };
}

export function updateCaseContactInfoFailed(error) {
  return {
    type: types.UPDATE_CASE_CONTACTINFO_FAILED,
    error
  };
}

export function onUpdateCaseContactInfoResponse(response) {
  return {
    type: types.UPDATE_CASE_CONTACTINFO_RESPONSE,
    response
  };
}

export function requestUpdateCaseMDInfo(editCaseMDInfoRequest) {
  return {
    type: types.UPDATE_CASE_MDINFO_REQUEST,
    updateCaseMDInfoRequest: editCaseMDInfoRequest
  };
}

export function updateCaseMDInfoFailed(error) {
  return {
    type: types.UPDATE_CASE_MDINFO_FAILED,
    error
  };
}

export function onUpdateCaseMDInfoResponse(response) {
  return {
    type: types.UPDATE_CASE_MDINFO_RESPONSE,
    response
  };
}

export function requestUpdateCaseBCHInfo(editCaseBCHInfoRequest) {
  return {
    type: types.UPDATE_CASE_BCHINFO_REQUEST,
    updateCaseBCHInfoRequest: editCaseBCHInfoRequest
  };
}

export function updateCaseBCHInfoFailed(error) {
  return {
    type: types.UPDATE_CASE_BCHINFO_FAILED,
    error
  };
}

export function onUpdateCaseBCHInfoResponse(response) {
  return {
    type: types.UPDATE_CASE_BCHINFO_RESPONSE,
    response
  };
}

export function requestGetCaseById(acase) {
  return {
    type: types.GET_CASE_BY_ID_REQUEST,
    acase: acase
  };
}

export function setCaseId(caseId) {
  return {
    type: types.SET_CASE_ID,
    caseId
  };
}

export function setLocalCountryName(countryname) {
  return {
    type: types.SET_LOCAL_COUNTRYNAME,
    localCountryName: countryname
  };
}

export function setDataUpdated(dataUpdated) {
  return {
    type: types.SET_DATA_UPDATED,
    dataUpdated
  };
}

export function setViewSummary(viewSummary) {
  return {
    type: types.SET_VIEW_SUMMARY,
    viewSummary
  };
}

export function setSaveBasicInfo(saveBasicInfo) {
  return {
    type: types.SET_SAVE_BASICINFO,
    saveBasicInfo
  };
}

export function setSaveContactInfo(saveContactInfo) {
  return {
    type: types.SET_SAVE_CONTACTINFO,
    saveContactInfo
  };
}
export function setSaveMDInfo(saveMDInfo) {
  return {
    type: types.SET_SAVE_MDINFO,
    saveMDInfo
  };
}
export function setSaveAdditionalInfo(saveAdditionalInfo) {
  return {
    type: types.SET_SAVE_ADDITIONALINFO,
    saveAdditionalInfo
  };
}

export function setActiveStep(activeStep) {
  return {
    type: types.SET_ACTIVE_STEP,
    activeStep
  };
}

export function requestAccessCase(accessRequest) {
  return {
    type: types.ACCESS_CASE_REQUEST,
    accessRequest: accessRequest
  };
}

export function accessCaseFailed(error) {
  return {
    type: types.ACCESS_CASE_FAILED,
    error
  };
}

export function onAccessCaseResponse(response) {
  return {
    type: types.ACCESS_CASE_RESPONSE,
    response
  };
}

export function setShowWelcome(showWelcome) {
  return {
    type: types.SET_SHOW_WELCOME,
    showWelcome: showWelcome
  };
}
